import { render, staticRenderFns } from "./WhoIsOnLeaveDashboard.vue?vue&type=template&id=a95a19f6"
import script from "./WhoIsOnLeaveDashboard.vue?vue&type=script&lang=js"
export * from "./WhoIsOnLeaveDashboard.vue?vue&type=script&lang=js"
import style0 from "./WhoIsOnLeaveDashboard.vue?vue&type=style&index=0&id=a95a19f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports